import { Toaster } from 'react-hot-toast';
import { Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import importAll from 'import-all.macro';
import { Fragment, useEffect } from 'react';
import UserSession from './components/UserSession';
import Callback from './pages/Callback';
import { getRoutes } from './utils';
import styles from './App.module.scss';
import { createPortal } from 'react-dom';
import Protected from './components/UserSession/Protected';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

const isDev = process.env.NODE_ENV === 'development';
const routes = getRoutes(importAll.sync('./pages/*/index.tsx'));
const client = new QueryClient({
  defaultOptions: {
    mutations: {
      networkMode: isDev ? 'always' : undefined,
    },
    queries: {
      networkMode: isDev ? 'always' : undefined,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

function App() {
  useEffect(() => {
    window.setTimeout(() => {
      window.requestAnimationFrame(() => {
        document.documentElement.classList.add('animate');
      });
    }, 50);
  }, []);

  return (
    <QueryClientProvider client={client}>
      <UserSession>
        <Routes>
          {routes.map((route, key) => {
            const Element = route;
            const { isProtected, protectedProps, ...props } =
              route.routeProps ?? {};
            const Wrapper = isProtected ? Protected : Fragment;
            return (
              <Route
                {...props}
                element={
                  <Wrapper {...protectedProps}>
                    <Element />
                  </Wrapper>
                }
                key={key}
              />
            );
          })}
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/callback" element={<Callback />} />
        </Routes>
      </UserSession>
      {createPortal(
        <Toaster
          toastOptions={{
            className: styles.toast,
          }}
        />,
        document.getElementById('toast')!,
      )}
    </QueryClientProvider>
  );
}

export default App;
